import styles from './Module.module.css'; //styles
import helpers from '../helpers.js';
import Icon from './Icon.js';
import { useCallback } from 'react';


/*
    Module
        props:
            spanRow: grid row height (1 = 100px)
            spanColumn: grid column width (/24 eg: 6 takes up a quarter of the screen)
            icon: Can be either:
                - A react-icons name (string starting with "Fa", "Hi", "Io", etc.)
                - An image URL (string with http or data URL)
                - Empty string for no icon
            iconSize: size of icon in pixels (default: 20)
*/
const Module = (props) => {
    const renderIcon = useCallback(() => {
        const icon = props.icon;
        if (icon == null || icon === "") {
            return null;
        } else if (typeof icon === "string" && icon.length > 20 && (icon.startsWith('http') || icon.startsWith('data:'))) {
            // Image URL
            return <img className={styles.headerIcon} src={icon} alt="module icon" />
        } else if (typeof icon === "string" && icon.length > 2 && (icon.startsWith('Fa') || icon.startsWith('Hi') || icon.startsWith('Io'))) {
            // React icon name
            return <Icon name={icon} size={props.iconSize} className={styles.headerIcon} />
        } else {
            // Legacy text/emoji icon
            return <span className={styles.headerIcon}>{icon}</span>
        }
    }, [props.icon, props.iconSize])

    return(
        <div className={styles.moduleContainer} style={{gridRow: "span " + props.spanRow, gridColumn: "span " + props.spanColumn, height: props.height, background: props.background}}>
            <h3 className={styles.header}>
                {renderIcon()}
                {props.name}
            </h3>
            {props.name !== "" ? <div className={styles.line}/> : null }
            {props.children}
        </div>
    )
}

Module.defaultProps = {
    height: "100%",
    background: "",
    icon: "",
    iconSize: 20,
    name: ""
  };

export default Module;